<script lang="ts" setup>
import CartNotification from '~/components/cart/CartNotification.vue'
import { useCartStore } from '~/store/cart'

const cartStore = useCartStore()

const statusPriority: Record<string, number> = {
  error: 0,
  warning: 1,
  help: 2,
  info: 3,
  success: 4
}

const sortedNotifications = computed(() => {
  return [...cartStore.notifications].sort((a, b) => {
    return statusPriority[a.status] - statusPriority[b.status]
  })
})
</script>

<template>
  <div v-if="cartStore.notifications.length">
    <CartNotification
      v-for="(notification, index) in sortedNotifications"
      :key="index"
      class="mb-2"
      :notification="notification"
    />
  </div>
</template>
